import React from 'react';
import { fmtEUR } from '../calculations/aquapodCalculations.js';

/**
 * Étape 5 : retour sur investissement, à partir du modèle choisi (étape 3) et du budget estimé
 * (étape 4). Payback = CAPEX total / économie nette annuelle (déjà nette du coût de traitement).
 */
const RoiStep = ({
  valorizedVolume, selectedModel, opex, capex, payback,
  currentStep, totalSteps, goPrevious,
}) => (
  <div className="apv2-step-card">
    <div className="apv2-step-header">
      <div className="apv2-step-header-text">
        <span className="apv2-step-eyebrow">Réutilisation des eaux grises</span>
        <h2 className="apv2-step-heading">Retour sur investissement</h2>
      </div>
      <span className="apv2-step-counter">{currentStep + 1} / {totalSteps}</span>
    </div>
    <div className="apv2-step-body">

      <p className="apv2-sim-hint">Repris du modèle choisi à l'étape 3 et du budget estimé à l'étape 4.</p>

      <div className="apv2-summary-cards">
        <div className="apv2-summary-card">
          <span className="apv2-summary-value">{selectedModel ? selectedModel.label : '—'}</span>
          <span className="apv2-summary-label">modèle Aquapod retenu</span>
        </div>
        <div className="apv2-summary-card">
          <span className="apv2-summary-value">{valorizedVolume.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} m³</span>
          <span className="apv2-summary-label">eau valorisée / an</span>
        </div>
        <div className="apv2-summary-card apv2-summary-card--secondary">
          <span className="apv2-summary-value">{fmtEUR(capex.total)} €</span>
          <span className="apv2-summary-label">CAPEX estimé (Aquapod + plomberie)</span>
        </div>
      </div>

      <div className="rw-sub-label" style={{ marginTop: 24 }}>Économie nette et retour sur investissement</div>
      <p className="apv2-sim-hint">
        Économie nette annuelle = volume valorisé × (prix de l'eau du réseau − coût de l'eau traitée). Le coût
        de traitement (maintenance de l'Aquapod) est donc déjà déduit de l'économie ci-dessous.
      </p>

      <div className="apv2-summary-cards">
        <div className="apv2-summary-card">
          <span className="apv2-summary-value">{fmtEUR(opex.annualSavings)} €</span>
          <span className="apv2-summary-label">économie nette annuelle</span>
        </div>
        <div className="apv2-summary-card apv2-summary-card--secondary">
          <span className="apv2-summary-value">
            {payback ? `${payback.paybackYears.toFixed(1)} ans` : '—'}
          </span>
          <span className="apv2-summary-label">retour sur investissement</span>
        </div>
      </div>

      <p className="apv2-sim-hint" style={{ marginTop: 12 }}>
        {payback
          ? `Sur la base d'un CAPEX de ${fmtEUR(capex.total)} € et d'une économie nette de ${fmtEUR(opex.annualSavings)} €/an, l'installation serait amortie en ${payback.paybackYears.toFixed(1)} ans.`
          : "Pas d'économie nette calculable pour l'instant — vérifie le gisement/besoin (étapes 1 et 2), le modèle Aquapod choisi (étape 3) et le prix de l'eau du réseau (étape 4). Si le coût de traitement dépasse le prix du réseau, aucun retour sur investissement n'est atteint."}
      </p>
    </div>
    <div className="apv2-step-footer">
      <button type="button" className="apv2-footer-btn-ghost" onClick={goPrevious} disabled={currentStep === 0}>
        ← Précédent
      </button>
      <span />
    </div>
  </div>
);

export default RoiStep;
